export const qk = {
    deals: ["deals"] as const,
    deal: (id: string) => ["deals", id] as const,

    activities: ["activities"] as const,
    activity: (id: string) => ["activities", id] as const,

    companies: ["companies"] as const,
    company: (id: string) => ["companies", id] as const,

    contacts: ["contacts"] as const,
    contact: (id: string) => ["contacts", id] as const,

    users: ["users"] as const,
    user: (id: string) => ["users", id] as const,

    bootstrap: ["bootstrap"] as const,

    health: ["health"] as const,
};
